import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_REQUESTFORPROPOSAL } from "../../../../utils/constants";
import documentTemplateService from "../../../../services/general/documentTemplateService";

const useRFPSchema = () =>
  useQuery<string[], Error>({
    queryKey: [`${CACHE_KEY_REQUESTFORPROPOSAL}Schema`],
    queryFn: () =>
      documentTemplateService.GetSchema("RequestForProposalModule"),
    initialData: [],
  });

export default useRFPSchema;
